import { useContext, useEffect, useState } from "react";
import FormikInput from "./FormikFieldCustom";
import { FormikProvider, useFormik } from "formik";
import { GetLatLngWithAddress } from "../utils/getLatLngWithAddress";
import {
  GetRegionsService,
  SearchAuctionsService,
} from "../services/auctions.service";
import { StatusCodes } from "http-status-codes";
import { ICategoryBaseResponse } from "../pages/admin/categories/category.interface";
import { GetUserCategories } from "../services/categories.service";
import { useLocation, useNavigate } from "react-router-dom";
import { FoundedAuctionContext } from "../context/foundedAuctionsContext";
import SearchInput from "./CustomAutoComplete";
import OverlayLoading from "./overlayLoading";
import { SeachedAuctionParamsContext } from "../context/searchedAuctionsParams";
const AuctionHeaderForm = ({
  selectedRegion,
  params,
}: {
  selectedRegion?: string;
  params?: any;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSearchedAuctionsValues } = useContext(SeachedAuctionParamsContext);
  const [regions, setRegions] = useState<string[]>([]);
  const { setFoundedAuctions } = useContext(FoundedAuctionContext);
  const [categories, setCategories] = useState<ICategoryBaseResponse>();
  const [miles] = useState<any[]>([
    { label: "10 Miles", value: 10 },
    { label: "30 Miles", value: 30 },
    { label: "50 Miles", value: 50 },
    { label: "70 Miles", value: 70 },
    { label: "90 Miles", value: 90 },
    { label: "120 Miles", value: 120 },
  ]);
  let initialValues = {
    keyword: "",
    radius: "",
    category: "",
    zip: "",
    region: "",
  };

  useEffect(() => {
    if (selectedRegion) setSearchedAuctionsValues({ region: selectedRegion });
  }, [selectedRegion]);
  const validate = (values: any) => {
    const errors: any = {};
    if (values.radius && !values.zip) {
      errors.zip = "zip is required";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: location?.state?.params
      ? location?.state?.params
      : initialValues,
    validate: validate,
    onSubmit: async (data, { setSubmitting }) => {
      setSubmitting(true);
      setSearchedAuctionsValues(data);
      let params: any = {};
      let coordinates: any = {};
      if (data?.zip) {
        coordinates = await GetLatLngWithAddress(data?.zip);
      }
      if (location.pathname === "/") {
        navigate("/auctions", {
          state: { params: data },
        });
      }
      const response = await SearchAuctionsService({
        ...params,
        lat: coordinates?.lat,
        lng: coordinates?.lng,
        ...data,
      } as any);
      if (response.status && response.status_code === StatusCodes.OK)
        setFoundedAuctions(response.data.auctions);

      setSubmitting(false);
    },
  });
  const getCategories = async () => {
    const response = await GetUserCategories();
    if (response.status && response.status_code === StatusCodes.OK)
      setCategories(response);
  };
  const getRegions = async () => {
    const response = await GetRegionsService();
    if (response.status && response.status_code === StatusCodes.OK)
      setRegions(response.data.map((x: any) => x.toLowerCase()));
    formik.setFieldValue("region", selectedRegion?.toLowerCase());
  };
  useEffect(() => {
    if (location.pathname === "/auctions") getRegions();

    getCategories();
  }, []);
  return (
    <FormikProvider value={formik}>
      {formik.isSubmitting && <OverlayLoading />}
      <div>
        <form
          onSubmit={formik.handleSubmit}
          className="m-5 flex gap-2 mt-6 items-center justify-center"
        >
          <SearchInput formik={formik} />
          <FormikInput
            disabled={formik.values.region ? true : false}
            name="zip"
            value={formik.values.region ? "" : formik.values.zip}
            label="zip code"
            type="text"
          />
          <FormikInput
            disabled={formik.values.region ? true : false}
            type="select"
            name="radius"
            value={formik.values.region ? "" : formik.values.radius}
            label="Select distance"
            options={miles?.map((x) => {
              return { label: x.label, value: x.value };
            })}
          />
          <FormikInput
            name="category"
            type="select"
            label="Select categories"
            options={categories?.data.map((x) => {
              return { label: x.name, value: x.id };
            })}
          />
          {location.pathname === "/auctions" && (
            <FormikInput
              name="region"
              disabled={params?.zip && params?.radius ? true : false}
              type="select"
              label="Select Region"
              options={regions?.map((x) => {
                return { label: x, value: x };
              })}
            />
          )}
          <button
            type="submit"
            className="mt-4 border-2 px-1 border-gray-600 bg-gray-400"
          >
            Search
          </button>
        </form>
      </div>
    </FormikProvider>
  );
};

export default AuctionHeaderForm;
